import React from 'react';
import { Typography, Card, Layout, Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Paragraph } = Typography;
const { Content } = Layout;

const TermsOfService = () => {
  const navigate = useNavigate();

  return (
    <Layout style={{ minHeight: '100vh', background: 'linear-gradient(145deg, #FAFBFE 0%, #F4F6FB 30%, #EEF2FA 100%)' }}>
      <Content style={{ padding: '24px 48px', maxWidth: 1200, margin: '0 auto' }}>
        <div style={{ marginBottom: 24 }}>
          <Button 
            icon={<ArrowLeftOutlined />} 
            onClick={() => navigate('/')}
            style={{ marginBottom: 16 }}
          >
            Back to Home
          </Button>
        </div>

        <Card style={{ boxShadow: '0 4px 16px rgba(139, 122, 174, 0.12)', borderRadius: 16 }}>
          <Title level={1} style={{ color: '#2D3748', marginBottom: 32 }}>Terms of Service</Title>
          
          <Paragraph style={{ fontSize: '14px', color: '#718096', marginBottom: 32 }}>
            <strong>Last updated:</strong> {new Date().toLocaleDateString()}
          </Paragraph>

          <Title level={2} style={{ color: '#2D3748' }}>1. Acceptance of Terms</Title>
          <Paragraph style={{ color: '#4A5568' }}>
            By accessing or using Vouchain's B2B voucher marketplace platform, you agree to be bound by these Terms of Service. 
            If you do not agree to these terms, you may not use our services. These terms apply to all users, including businesses, 
            distributors, and authorized representatives.
          </Paragraph>

          <Title level={2} style={{ color: '#2D3748' }}>2. Service Description</Title>
          <Paragraph style={{ color: '#4A5568' }}>
            Vouchain operates a B2B marketplace that connects businesses with voucher suppliers. Our platform facilitates:
          </Paragraph>
          <ul style={{ color: '#4A5568', marginLeft: 16 }}>
            <li>Bulk purchasing of digital vouchers and gift cards</li>
            <li>Instant delivery of voucher codes upon payment confirmation</li>
            <li>Account management and transaction tracking</li>
            <li>Customer support and dispute resolution</li>
            <li>Credit and payment management services</li>
          </ul>

          <Title level={2} style={{ color: '#2D3748' }}>3. Eligibility and Registration</Title>
          <Paragraph style={{ color: '#4A5568' }}>
            To use our services, you must:
          </Paragraph>
          <ul style={{ color: '#4A5568', marginLeft: 16 }}>
            <li>Be a legally registered business entity</li>
            <li>Have authorization to make purchasing decisions</li>
            <li>Provide accurate and complete registration information</li>
            <li>Maintain the confidentiality of your account credentials</li>
            <li>Comply with all applicable laws and regulations</li>
          </ul>

          <Title level={2} style={{ color: '#2D3748' }}>4. Ordering and Payment</Title>
          <Paragraph style={{ color: '#4A5568' }}>
            <strong>Order Process:</strong>
          </Paragraph>
          <ul style={{ color: '#4A5568', marginLeft: 16 }}>
            <li>All orders are subject to availability and confirmation</li>
            <li>Prices are quoted in the currency specified on the platform</li>
            <li>Orders become binding upon payment confirmation</li>
            <li>Bulk pricing and credit terms may apply based on your account status</li>
          </ul>
          <Paragraph style={{ color: '#4A5568' }}>
            <strong>Payment Terms:</strong>
          </Paragraph>
          <ul style={{ color: '#4A5568', marginLeft: 16 }}>
            <li>Payment must be completed within the specified billing period</li>
            <li>Payment proof must be uploaded for verification and processing</li>
            <li>We accept major credit cards, bank transfers, and approved payment methods</li>
            <li>Late payments may incur fees and impact credit standing</li>
            <li>All payments are processed securely through certified payment processors</li>
          </ul>

          <Title level={2} style={{ color: '#2D3748' }}>5. Voucher Delivery and Usage</Title>
          <Paragraph style={{ color: '#4A5568' }}>
            <strong>Delivery:</strong>
          </Paragraph>
          <ul style={{ color: '#4A5568', marginLeft: 16 }}>
            <li>Digital vouchers are delivered upon payment confirmation</li>
            <li>Voucher codes are accessible through your account dashboard</li>
          </ul>
          <Paragraph style={{ color: '#4A5568' }}>
            <strong>Usage Restrictions:</strong>
          </Paragraph>
          <ul style={{ color: '#4A5568', marginLeft: 16 }}>
            <li>Vouchers are intended for legitimate business use only</li>
            <li>Resale restrictions may apply depending on the voucher type</li>
            <li>Vouchers have expiration dates and redemption limitations</li>
            <li>Fraudulent use may result in account termination</li>
          </ul>

          <Title level={2} style={{ color: '#2D3748' }}>6. Account Responsibilities</Title>
          <Paragraph style={{ color: '#4A5568' }}>
            You are responsible for:
          </Paragraph>
          <ul style={{ color: '#4A5568', marginLeft: 16 }}>
            <li>Maintaining accurate account information and business details</li>
            <li>Securing your account credentials and preventing unauthorized access</li>
            <li>Promptly reporting any suspicious activity or security breaches</li>
            <li>Complying with usage restrictions and platform policies</li>
            <li>Paying all fees and charges associated with your account</li>
          </ul>

          <Title level={2} style={{ color: '#2D3748' }}>7. Refunds and Returns</Title>
          <Paragraph style={{ color: '#4A5568' }}>
            <strong>Refund Policy:</strong>
          </Paragraph>
          <ul style={{ color: '#4A5568', marginLeft: 16 }}>
            <li>Digital vouchers are generally non-refundable once delivered</li>
          </ul>

          <Title level={2} style={{ color: '#2D3748' }}>8. Intellectual Property</Title>
          <Paragraph style={{ color: '#4A5568' }}>
            The Vouchain platform, including software, content, trademarks, and trade secrets, is protected by intellectual property laws. 
            You may not copy, modify, distribute, or create derivative works without our express written permission.
          </Paragraph>

          <Title level={2} style={{ color: '#2D3748' }}>9. Limitation of Liability</Title>
          <Paragraph style={{ color: '#4A5568' }}>
            Vouchain's liability is limited to the maximum extent permitted by law. We are not liable for:
          </Paragraph>
          <ul style={{ color: '#4A5568', marginLeft: 16 }}>
            <li>Indirect, incidental, or consequential damages</li>
            <li>Loss of profits, data, or business opportunities</li>
            <li>Issues arising from third-party voucher suppliers</li>
            <li>Force majeure events beyond our reasonable control</li>
          </ul>

          <Title level={2} style={{ color: '#2D3748' }}>10. Termination</Title>
          <Paragraph style={{ color: '#4A5568' }}>
            We may terminate or suspend your account for:
          </Paragraph>
          <ul style={{ color: '#4A5568', marginLeft: 16 }}>
            <li>Violation of these terms or platform policies</li>
            <li>Fraudulent or illegal activities</li>
            <li>Non-payment of outstanding fees</li>
            <li>Compromise of account security</li>
          </ul>

          <Title level={2} style={{ color: '#2D3748' }}>11. Governing Law</Title>
          <Paragraph style={{ color: '#4A5568' }}>
            These terms are governed by applicable laws. Any disputes will be resolved through appropriate legal procedures.
          </Paragraph>

          <Title level={2} style={{ color: '#2D3748' }}>12. Changes to Terms</Title>
          <Paragraph style={{ color: '#4A5568' }}>
            We reserve the right to modify these terms at any time. Material changes will be communicated via email and 
            platform notifications. Continued use of our services constitutes acceptance of the updated terms.
          </Paragraph>
        </Card>
      </Content>
    </Layout>
  );
};

export default TermsOfService; 